import { useTranslation } from "react-i18next";

// The Memorandum of Understanding shown in the "Proceed" modal of the business
// registration page. Pure content: no state, so MoUModal stays readable.
// Section/heading styles come from the `.memorandum` rules in custom.css.
const MemorandumContent = () => {
    const { t } = useTranslation();

    return (
        <>
            <p className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">
                {t('memorandum.preamble')}
            </p>

            <section>
                <div>{t('memorandum.sections.conditions.title')}</div>
                <p className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">{t('memorandum.sections.conditions.description')}</p>

                <h3>{t('memorandum.sections.conditions.corporationsJapan.title')}</h3>
                <ol>
                    <li className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">{t('memorandum.sections.conditions.corporationsJapan.item1')}</li>
                    <li className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">
                        {t('memorandum.sections.conditions.corporationsJapan.item2')}
                    </li>
                </ol>

                <h3>{t('memorandum.sections.conditions.corporationsOutsideJapan.title')}</h3>
                <ol>
                    <li className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">
                        {t('memorandum.sections.conditions.corporationsOutsideJapan.item1')}
                    </li>
                    <li className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">
                        {t('memorandum.sections.conditions.corporationsOutsideJapan.item2')}
                    </li>
                </ol>
            </section>

            <section>
                <div>{t('memorandum.sections.calculationOfFare.title')}</div>
                <p className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">
                    {t('memorandum.sections.calculationOfFare.description')}
                </p>
            </section>

            <section>
                <div>{t('memorandum.sections.commission.title')}</div>
                <p className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">
                    {t('memorandum.sections.commission.description')}
                </p>
            </section>

            <section>
                <div>{t('memorandum.sections.commissionAdjustment.title')}</div>
                <p className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">
                    {t('memorandum.sections.commissionAdjustment.description')}
                </p>
            </section>

            <section>
                <p>{t('memorandum.sections.payment.title')}</p>

                <h3>{t('memorandum.sections.payment.corporationsJapan.title')}</h3>
                <p className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">
                    {t('memorandum.sections.payment.corporationsJapan.description')}
                </p>

                <h3>{t('memorandum.sections.payment.corporationsOutsideJapan.title')}</h3>
                <p className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">
                    {t('memorandum.sections.payment.corporationsOutsideJapan.description')}
                </p>
                <p className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">
                    {t('memorandum.sections.payment.corporationsOutsideJapan.additionalInfo')}
                </p>
            </section>

            <section>
                <div>{t('memorandum.sections.cancellationPolicy.title')}</div>
                <ul>
                    {t('memorandum.sections.cancellationPolicy.oneVehicle.title')}
                    <li style={{ listStyle: 'none' }}>
                        <ul>
                            <li className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">{t('memorandum.sections.cancellationPolicy.oneVehicle.item1')}</li>
                            <li className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">{t('memorandum.sections.cancellationPolicy.oneVehicle.item2')}</li>
                            <li className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">{t('memorandum.sections.cancellationPolicy.oneVehicle.item3')}</li>
                            <li className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">{t('memorandum.sections.cancellationPolicy.oneVehicle.item4')}</li>
                        </ul>
                    </li>
                </ul>
                <ul>
                    {t('memorandum.sections.cancellationPolicy.twoToFourVehicles.title')}
                    <li style={{ listStyle: 'none' }}>
                        <ul>
                            <li className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">{t('memorandum.sections.cancellationPolicy.twoToFourVehicles.item1')}</li>
                            <li className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">{t('memorandum.sections.cancellationPolicy.twoToFourVehicles.item2')}</li>
                            <li className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">{t('memorandum.sections.cancellationPolicy.twoToFourVehicles.item3')}</li>
                            <li className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">{t('memorandum.sections.cancellationPolicy.twoToFourVehicles.item4')}</li>
                        </ul>
                    </li>
                </ul>

                <ul>
                    {t('memorandum.sections.cancellationPolicy.fiveOrMoreVehicles.title')}
                    <li style={{ listStyle: 'none' }}>
                        <ul>
                            <li className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">{t('memorandum.sections.cancellationPolicy.fiveOrMoreVehicles.item1')}</li>
                            <li className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">{t('memorandum.sections.cancellationPolicy.fiveOrMoreVehicles.item2')}</li>
                            <li className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">{t('memorandum.sections.cancellationPolicy.fiveOrMoreVehicles.item3')}</li>
                            <li className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">{t('memorandum.sections.cancellationPolicy.fiveOrMoreVehicles.item4')}</li>
                        </ul>
                    </li>
                </ul>

                <ul>
                    {t('memorandum.sections.cancellationPolicy.agreementPrecedence.description')}
                </ul>

                <ul>
                    {t('memorandum.sections.cancellationPolicy.scopeOfApplication.title')}
                    <p>
                        {t('memorandum.sections.cancellationPolicy.scopeOfApplication.description')}
                    </p>
                </ul>

                <ul>
                    {t('memorandum.sections.cancellationPolicy.forceMajeure.title')}
                    <p>
                        {t('memorandum.sections.cancellationPolicy.forceMajeure.description1')}
                        <br />
                        {t('memorandum.sections.cancellationPolicy.forceMajeure.description2')}
                    </p>
                </ul>
            </section>

            <section>
                <div>{t('memorandum.sections.scheduleChanges.title')}</div>
                <ul>
                    <li className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">
                        {t('memorandum.sections.scheduleChanges.higherAmount')}
                    </li>
                    <li className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">
                        {t('memorandum.sections.scheduleChanges.lowerAmount')}
                    </li>
                </ul>
            </section>
            <section>
                <div>{t('memorandum.sections.scopeOfApplicationStandalone.title')}</div>
                <p className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">
                    {t('memorandum.sections.scopeOfApplicationStandalone.description')}
                </p>
            </section>
            <section>
                <div>{t('memorandum.sections.meetService.title')}</div>
                <p className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">
                    {t('memorandum.sections.meetService.item1')}
                    <br />
                    {t('memorandum.sections.meetService.item2')}
                    <br />
                    {t('memorandum.sections.meetService.item3')}
                    <br />
                    {t('memorandum.sections.meetService.item4')}
                    <br />
                    {t('memorandum.sections.meetService.item5')}
                </p>
            </section>

            <section>
                <div>{t('memorandum.sections.vipMeetService.title')}</div>
                <p className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">
                    {t('memorandum.sections.vipMeetService.item1')}
                    <br />
                    {t('memorandum.sections.vipMeetService.item2')}
                    <br />
                    {t('memorandum.sections.vipMeetService.item3')}
                    <br />
                    {t('memorandum.sections.vipMeetService.item4')}
                </p>
            </section>

            <section>
                <div>{t('memorandum.sections.conciergeFee.title')}</div>
                <p className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">{t('memorandum.sections.conciergeFee.description')}</p>
            </section>

            <section>
                <div>{t('memorandum.sections.accidents.title')}</div>
                <div>
                    {t('memorandum.sections.accidents.description')}
                </div>
                <ul className="tw:mb-0">
                    <li className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">{t('memorandum.sections.accidents.coverage')}</li>
                </ul>
            </section>

            <section>
                <div>{t('memorandum.sections.contractPeriod.title')}</div>
                <p className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">
                    {t('memorandum.sections.contractPeriod.description')}
                </p>
            </section>

            <section>
                <div>{t('memorandum.sections.termination.title')}</div>
                <p className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">{t('memorandum.sections.termination.description')}</p>
            </section>

            <section>
                <div>{t('memorandum.sections.jurisdictionalCourt.title')}</div>
                <p className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">
                    {t('memorandum.sections.jurisdictionalCourt.description')}
                </p>
            </section>

            <section>
                <div>{t('memorandum.sections.consultation.title')}</div>
                <p className="tw:!text-[14px] tw:!font-[400] tw:!text-[#000000]">
                    {t('memorandum.sections.consultation.description')}
                </p>
            </section>
        </>
    );
};

export default MemorandumContent;
